<section class="choose-clothes">
  <div class="align-text">
  <p class="choose">
    {{ "Choose.Clothes" | translate }}
  </p>
</div>

  <h1 class="big-text">{{ "Round.Collar" | translate }}</h1>
  <div class="container">
    <div class="img-container" *ngFor="let maillot of maillotsColRond;">
      <img
        (click)="goNextStep(maillot)"
        src="https://strapi.alkesoccer.com{{maillot.Image.url}}"
        alt=""
        class="choose-tee"
      />
      <p>{{maillot.Name | translate}}</p>
    </div>
  </div>

  <h1 class="big-text">{{ "V.Collar" | translate }}</h1>
  <div class="container" alt="col-rond">
    <div class="img-container" *ngFor="let maillot of maillotsColV;">
      <img
        (click)="goNextStep(maillot)"
        src="https://strapi.alkesoccer.com{{maillot.Image.url}}"
        alt=""
        class="choose-tee"
      />
      <p>{{maillot.Name | translate}}</p>
    </div>
  </div>

  <h1 class="big-text">{{ "Only.Shorts" | translate }}</h1>
  <div class="container" alt="col-rond">
    <div class="img-container" *ngFor="let short of shortModeles;" >
      <img
        (click)="goNextStepShort(short)"
        src="https://strapi.alkesoccer.com{{short.image[0].url}}"
        alt=""
        class="choose-short"
      />
      <p>{{short.nom | translate}}</p>
    </div>
  </div>

</section>
